// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner___2QkmQ","heading":"heading___2KPQb","close":"close___1oW31","action":"action___18U8U"};